import { httpPost, httpPostFile, httpDownload, httpGet } from '../../../utils/api.utils';
import { getLocalTimeZone } from '../../../utils/helpers.utils';
import { DEFAULT_TABLE_RESULT_MODEL, DEFAULT_TABLE_RESULT_EQUIPMENT_DROPDOWN_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import Moment from 'moment';
import { actions } from 'react-redux-form';

import {
    getEquipmentdropDownList,
    getInventoryEquipmentComments,
    getInventoryEquipment,
    setInventoryEquipmentError,
    setInventoryEquipmentColSearchStr,
    sortInventoryEquipmentItems,
    setInventoryEquipmentPageSize,
    setInventoryEquipmentFilter,
    applyInventoryEquipmentFilter,
    getInventoryEquipmentDetailsById,
    inventoryEquipmentModel,
    setFormSubmitted,
    setDefaultInventoryEquipment,
    resetInventoryEquipmentData
} from '../../../constants/model-reducers/external/inventory/circuit-details/equipment.settings';

export const equipmentInitialState = inventoryEquipmentModel;

const defaultState = () => ({
    isInventoryEquipmentLoaded: false,
    isEquipmentdropDownListLoaded: false,
    isInventoryEquipmentError: false,
    inventoryEquipmentItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryEquipmentColSort: '',
    inventoryEquipmentIsSortedAsc: true,
    inventoryEquipmentTableFilterList: [],
    inventoryEquipmentTableFilterApply: false,
    formSubmitted: false,
    inventoryEquipmentDetails: {
        equipmentId : 0,
        equipmentTypeId: 0,
        model : "",
        productName: "",
        equipmentStatusId: 0,
        vendorId : 0,
        currency : "",
        circuitTypeId: 0,
        contractId : 0,
        orderCost : "0.00",
        discountedOrderCost : "0.00",
        mrc : "0.00",
        nrc : "0.00",
        glCodeId : 0,
        costCodeId: 0,
        companyCodeId : 0,
        isLoaded: false,
        vipId : 1,
    }
});

const initialState = defaultState();

export const inventoryEquipmentActions = {
    setDefaultInventoryEquipment: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultInventoryEquipment,
            inventoryItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getInventoryEquipment: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryEquipment.inventoryEquipmentItems;
        const { inventoryEquipmentIsSortedAsc,inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply, inventoryEquipmentColSort } = state().inventoryEquipment;
        var data = {
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryEquipmentColSort,
            IsSortAscending: inventoryEquipmentIsSortedAsc,
            TableFilterList: inventoryEquipmentTableFilterList,
            ApplyFilter: inventoryEquipmentTableFilterApply
        };

        var inventoryItems = await httpPost('external/inventory/getEquipmentItems', data);
        if (inventoryItems.ok === false) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        } else {
            dispatch({
                type: getInventoryEquipment,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        }
    },
    setResetSearch: () => async (dispatch, state) => {
        
        const { inventoryEquipmentItems } = state().inventoryEquipment;
        var inventoryEquipmentItemsUpd = {
            ...inventoryEquipmentItems,
            "Headers": {}
        }

        dispatch({
            type: setInventoryEquipmentColSearchStr,
            data: inventoryEquipmentItemsUpd,
            isInventoryEquipmentError: false,
            isInventoryEquipmentLoaded: false
        });
    },
    setInventoryEquipmentColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryEquipmentItems } = state().inventoryEquipment;
        var inventoryEquipmentItemsUpd = {
            ...inventoryEquipmentItems,
            "Headers": {
                ...inventoryEquipmentItems.Headers,
                [key]: {

                    ...inventoryEquipmentItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryEquipmentColSearchStr,
            data: inventoryEquipmentItemsUpd,
            isInventoryEquipmentError: false,
            isInventoryEquipmentLoaded: true
        });
    },
    sortInventoryEquipmentItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().inventoryEquipment.inventoryEquipmentItems.Pagination;
        const { inventoryEquipmentItems, inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply } = state().inventoryEquipment;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: inventoryEquipmentItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryEquipmentItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: inventoryEquipmentTableFilterList,
            ApplyFilter: inventoryEquipmentTableFilterApply
        };
        var resInventoryEquipmentItems = await httpPost('external/inventory/getEquipmentItems', data);
        if (resInventoryEquipmentItems.ok === false) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        } else {
            dispatch({
                type: sortInventoryEquipmentItems,
                inventoryEquipmentItems: Object.keys(resInventoryEquipmentItems).length > 0 ? resInventoryEquipmentItems : DEFAULT_TABLE_RESULT_MODEL,
                inventoryEquipmentColSort: columnClicked,
                inventoryEquipmentIsSortedAsc: isSortedAsc,
                isInventoryEquipmentLoaded: true
            });
        }
    },

    resizeInventoryEquipmentPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryEquipmentPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractInventoryEquipments: () => async (dispatch, state) => {
        const { Headers } = state().inventoryEquipment.inventoryEquipmentItems;
        const { inventoryEquipmentIsSortedAsc, inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply, inventoryEquipmentColSort } = state().inventoryEquipment;

        const dealName = sessionStorage.getItem('DealName');
        var filename = `ATEM ${dealName} Equipment Extract – ${Moment(new Date()).format('MMDDYYYY').toString()}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryEquipmentColSort,
            IsSortAscending: inventoryEquipmentIsSortedAsc,
            FileName: filename,
            TableFilterList: inventoryEquipmentTableFilterList,
            ApplyFilter: inventoryEquipmentTableFilterApply
        };

        httpDownload('external/inventory/getExtractEquipment', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInventoryEquipmentFilter: (tableFilter) => (dispatch, state) => {
        const { inventoryEquipmentTableFilterList } = state().inventoryEquipment;
        var filterList = [...inventoryEquipmentTableFilterList, tableFilter];

        dispatch({
            type: setInventoryEquipmentFilter,
            filterList: filterList
        })
    },

    removeInventoryEquipmentFilter: (removeIndex) => (dispatch, state) => {
        const { inventoryEquipmentTableFilterList } = state().inventoryEquipment;

        var filterList = inventoryEquipmentTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInventoryEquipmentFilter,
            filterList: filterList
        })
    },

    applyInventoryEquipmentFilter: (isApply) => (dispatch, state) => {
        const { inventoryEquipmentTableFilterList } = state().inventoryEquipment;

        dispatch({
            type: applyInventoryEquipmentFilter,
            applyFilter: isApply,
            filterList: isApply ? inventoryEquipmentTableFilterList : []
        });
    },

    submitRequest: () => async (dispatch, state) => {
        const { inventoryEquipmentForm } = state().form;
        const { inventoryEquipmentDropdownList } = state().inventoryEquipment;

        let isVipUser = !isNaN(parseInt(inventoryEquipmentForm.vipId)) && parseInt(inventoryEquipmentForm.vipId) > 0
            ? inventoryEquipmentDropdownList.IsVIPOption.find(s => s.Key === parseInt(inventoryEquipmentForm.vipId)).Value
            : null;
        let glCodeId = !isNaN(parseInt(inventoryEquipmentForm.glCodeId)) && inventoryEquipmentForm.glCodeId > 0
            ? inventoryEquipmentDropdownList.GlCodes.find(s => s.Key === inventoryEquipmentForm.glCodeId).Label
            : null;
        let costCodeId = !isNaN(parseInt(inventoryEquipmentForm.costCodeId)) && inventoryEquipmentForm.costCodeId > 0
            ? inventoryEquipmentForm.costCodeId
            : null;
        let cost1 = costCodeId > 0 ? inventoryEquipmentDropdownList.CostCenters.find(s => s.Key === costCodeId).Value.split("~")[1] : "";
        let cost2 = parseInt(inventoryEquipmentForm.companyCodeId) > 0 ? inventoryEquipmentDropdownList.CompanyCodes[parseInt(inventoryEquipmentForm.companyCodeId) -1] : "";
        let companyCode = !isNaN(parseInt(inventoryEquipmentForm.companyCodeId)) && parseInt(inventoryEquipmentForm.companyCodeId) > 0
            ? costCodeId > 0 && inventoryEquipmentDropdownList.CostCenters.find(s => s.Key === costCodeId).Value.split("~")[1] !== inventoryEquipmentDropdownList.CompanyCodes[parseInt(inventoryEquipmentForm.companyCodeId) -1]
                ? null
                : inventoryEquipmentDropdownList.CompanyCodes[parseInt(inventoryEquipmentForm.companyCodeId) -1]
            : null;
        var data = {
            EquipmentId: inventoryEquipmentForm.equipmentId,
            EquipmentTypeId: inventoryEquipmentForm.equipmentTypeId,
            Model: inventoryEquipmentForm.model,
            ProductName: inventoryEquipmentForm.productName,
            EquipmentStatusID: !isNaN(parseInt(inventoryEquipmentForm.equipmentStatusId)) ? parseInt(inventoryEquipmentForm.equipmentStatusId) : 0,
            VendorId: inventoryEquipmentForm.vendorId,
            CircuitTypeId: inventoryEquipmentForm.circuitTypeId,
            ContractId: inventoryEquipmentForm.contractId,
            Cost: isNaN(parseFloat(inventoryEquipmentForm.orderCost)) ? 0 : inventoryEquipmentForm.orderCost,
            DiscountedOrderCost: isNaN(parseInt(inventoryEquipmentForm.discountedOrderCost)) ? 0 : inventoryEquipmentForm.discountedOrderCost,
            MRC: isNaN(parseInt(inventoryEquipmentForm.mrc)) ? 0 : inventoryEquipmentForm.mrc,
            NRC: isNaN(parseInt(inventoryEquipmentForm.nrc)) ? 0 : inventoryEquipmentForm.nrc,
            GlCodeId: glCodeId,
            CostcodeID: costCodeId,
            CompanyCode: companyCode,
            IsVipUser: isVipUser,
            UserID: sessionStorage.getItem('UserID')
        }

        var res = await httpPost('external/inventory/saveInventoryEquipment', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }
        return res;
    },

    getNewEquipmentInventoryForm:() => (dispatch, state) => {
        const { inventoryEquipmentDropdownList } = state().inventoryEquipment;
        var initialEquipmentDetail = JSON.parse(JSON.stringify(initialState.inventoryEquipmentDetails));
        setEquipmentInventoryForm(dispatch, inventoryEquipmentDropdownList, initialEquipmentDetail, undefined);
    },

    getInventoryEquipmentDetailsById: (equipmentId) => async (dispatch, state) => {
        const { inventoryEquipmentDropdownList } = state().inventoryEquipment;
        var initialEquipmentDetail = JSON.parse(JSON.stringify(initialState.inventoryEquipmentDetails));
        dispatch(actions.change('inventoryEquipmentForm.isLoaded', false));
        var equipmentDetail = await httpGet('external/inventory/getInventoryEquipmentDetails/' + equipmentId);
        if(equipmentDetail !== null){
            setEquipmentInventoryForm(dispatch, inventoryEquipmentDropdownList, initialEquipmentDetail, equipmentDetail);
            dispatch(actions.change('inventoryEquipmentForm.isLoaded', true));
        }
        else{
            dispatch(actions.change('inventoryEquipmentForm.isLoaded', false));
            dispatch(actions.reset('inventoryEquipmentForm'));
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
            });
        }
    },

    getEquipmentdropDownList: () => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getInventoriesEquipmentDropdownList');
        if (res != null)
        {
            dispatch({
                type: getEquipmentdropDownList,
                isEquipmentdropDownListLoaded: true,
                inventoryEquipmentDropDownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_EQUIPMENT_DROPDOWN_MODEL,
            });
        }
        else{
            dispatch({
                type: setInventoryEquipmentError,
                isEquipmentdropDownListLoaded : false,
                isInventoryEquipmentError: true,
            });  
        }
    },
    getInventoryEquipmentComments: (equipmentID) => async (dispatch, state) => {
        var res = await httpGet('external/inventoryManager/getEquipmentComments?equipmentID=' + equipmentID + '&timeZone=' + getLocalTimeZone());

        if (res != null) {
            dispatch({
                type: getInventoryEquipmentComments,
                inventoryEquipmentComments: res,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        } else {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },
    postInventoryEquipmentComments: (equipmentID, filename, fileData, comment) => async (dispatch, state) => {
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("EquipmentID", equipmentID);

        var timeZone = getLocalTimeZone()

        var res = await httpPostFile('external/inventoryManager/setEquipmentComments?timeZone=' + timeZone, formData);

        if (res != null) {

            dispatch({
                type: getInventoryEquipmentComments,
                inventoryEquipmentComments: res,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        } else {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },
    saveInventoryEquipmentCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryEquipment.inventoryEquipmentItems;
        const { inventoryEquipmentIsSortedAsc, inventoryEquipmentColSort, inventoryEquipmentTableFilterList, inventoryEquipmentTableFilterApply } = state().inventoryEquipment;

        try {
            var userId = sessionStorage.getItem('UserID');
            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.EquipmentInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: false,
                isInventoryEquipmentLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },

                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryEquipmentColSort,
                IsSortAscending: inventoryEquipmentIsSortedAsc,
                TableFilterList: inventoryEquipmentTableFilterList,
                ApplyFilter: inventoryEquipmentTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getEquipmentItems', data);

            dispatch({
                type: getInventoryEquipment,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },

    deleteInventoryEquipmentComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/inventoryManager/equipmentInventoryDeleteComment/' + commentId + '/' + userId);

        if (res != null) {
            dispatch({
                type: getInventoryEquipmentComments,
                equipmentDeleteComment: res,
                isInventoryEquipmentLoaded: true,
                isInventoryEquipmentError: false
            });
        } else {
            dispatch({
                type: setInventoryEquipmentError,
                isInventoryEquipmentError: true,
                isInventoryEquipmentLoaded: false
            });
        }
    },

    checkDuplicate: () => async (dispatch, state) => {
        const { inventoryEquipmentForm } = state().form;   
        var data = {
            EquipmentId: inventoryEquipmentForm.equipmentId,
            Model: inventoryEquipmentForm.model,
            EquipmentTypeId: inventoryEquipmentForm.equipmentTypeId,
            VendorId: inventoryEquipmentForm.vendorId
        }
        var res = await httpPost('external/inventory/checkDuplicateEquipmentItem', data);
        return res;
    },

    resetInventoryEquipmentData: () => async (dispatch) => {
        dispatch({ type: resetInventoryEquipmentData, data: DEFAULT_TABLE_RESULT_MODEL });
    },
};

function setEquipmentInventoryForm(dispatch, inventoryEquipmentDropdownList, initialEquipmentDetail, equipmentDetail) {
    var inventoryEquipmentDetails = JSON.parse(JSON.stringify(initialEquipmentDetail));
    if(equipmentDetail){
        inventoryEquipmentDetails.equipmentId = equipmentDetail.EquipmentId;
        inventoryEquipmentDetails.equipmentTypeId = equipmentDetail.EquipmentTypeId;
        inventoryEquipmentDetails.model = equipmentDetail.Model;
        inventoryEquipmentDetails.productName = equipmentDetail.ProductName;
        inventoryEquipmentDetails.equipmentStatusId = equipmentDetail.EquipmentStatusID === null
        ? 0
        : parseInt(equipmentDetail.EquipmentStatusID);
        inventoryEquipmentDetails.vendorId = equipmentDetail.VendorId;
        inventoryEquipmentDetails.currency = equipmentDetail.Currency;
        inventoryEquipmentDetails.circuitTypeId = equipmentDetail.CircuitTypeId === null ? 0 : equipmentDetail.CircuitTypeId;
        inventoryEquipmentDetails.contractId = equipmentDetail.ContractId;
        inventoryEquipmentDetails.vipId = equipmentDetail.IsVipUser === null
            ? 0
            : !isNaN(parseInt(equipmentDetail.IsVipUser))
                ? parseInt(equipmentDetail.IsVipUser)
                : inventoryEquipmentDropdownList.IsVIPOption.find(s => s.Value.toUpperCase() === equipmentDetail.IsVipUser.toUpperCase()).Key;
        inventoryEquipmentDetails.orderCost = equipmentDetail.Cost;
        inventoryEquipmentDetails.discountedOrderCost = equipmentDetail.DiscountedOrderCost;
        inventoryEquipmentDetails.mrc = equipmentDetail.MRC;
        inventoryEquipmentDetails.nrc = equipmentDetail.NRC;
        inventoryEquipmentDetails.glCodeId = !isNaN(parseInt(equipmentDetail.GlCodeId))
            ? inventoryEquipmentDropdownList.GlCodes.find(s => s.Label === equipmentDetail.GlCodeId).Key
            : 0;
        inventoryEquipmentDetails.costCodeId = equipmentDetail.CostcodeID;
        inventoryEquipmentDetails.companyCodeId = equipmentDetail.CompanyCode === null
            ? 0
            : inventoryEquipmentDropdownList.CompanyCodes.findIndex(code => code === equipmentDetail.CompanyCode) + 1;
    }
    dispatch(actions.reset('inventoryEquipmentForm'));
    dispatch(actions.change('inventoryEquipmentForm.equipmentId', inventoryEquipmentDetails.equipmentId));
    dispatch(actions.change('inventoryEquipmentForm.equipmentTypeId', inventoryEquipmentDetails.equipmentTypeId));
    dispatch(actions.change('inventoryEquipmentForm.model', inventoryEquipmentDetails.model));
    dispatch(actions.change('inventoryEquipmentForm.productName', inventoryEquipmentDetails.productName));
    dispatch(actions.change('inventoryEquipmentForm.equipmentStatusId', inventoryEquipmentDetails.equipmentStatusId));
    dispatch(actions.change('inventoryEquipmentForm.vendorId', inventoryEquipmentDetails.vendorId));
    dispatch(actions.change('inventoryEquipmentForm.currency', inventoryEquipmentDetails.currency));
    dispatch(actions.change('inventoryEquipmentForm.circuitTypeId', inventoryEquipmentDetails.circuitTypeId));
    dispatch(actions.change('inventoryEquipmentForm.contractId', inventoryEquipmentDetails.contractId));
    dispatch(actions.change('inventoryEquipmentForm.vipId', inventoryEquipmentDetails.vipId));
    dispatch(actions.change('inventoryEquipmentForm.orderCost', inventoryEquipmentDetails.orderCost));
    dispatch(actions.change('inventoryEquipmentForm.discountedOrderCost', inventoryEquipmentDetails.discountedOrderCost));
    dispatch(actions.change('inventoryEquipmentForm.mrc', inventoryEquipmentDetails.mrc));
    dispatch(actions.change('inventoryEquipmentForm.nrc', inventoryEquipmentDetails.nrc));
    dispatch(actions.change('inventoryEquipmentForm.glCodeId', inventoryEquipmentDetails.glCodeId));
    dispatch(actions.change('inventoryEquipmentForm.costCodeId', inventoryEquipmentDetails.costCodeId));
    dispatch(actions.change('inventoryEquipmentForm.companyCodeId', inventoryEquipmentDetails.companyCodeId));
    dispatch({
        type: getInventoryEquipmentDetailsById,
        inventoryEquipmentDetails: inventoryEquipmentDetails,
        isInventoryEquipmentError: false,

    });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryEquipment:
            return {
                ...state,
                inventoryEquipmentItems: action.inventoryItems,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded,
                isInventoryEquipmentError: action.isInventoryEquipmentError
            };
        case setInventoryEquipmentError:
            return {
                ...state,
                isInventoryEquipmentError: action.isInventoryEquipmentError,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded
            }
        case getInventoryEquipmentComments:
            return {
                ...state,
                inventoryEquipmentComments: action.inventoryEquipmentComments
            };
        case setInventoryEquipmentColSearchStr:
            return {
                ...state,
                inventoryEquipmentItems: action.data,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded,
                isInventoryEquipmentError: action.isInventoryEquipmentError
            }
        case sortInventoryEquipmentItems:
            return {
                ...state,
                inventoryEquipmentItems: action.inventoryEquipmentItems,
                inventoryEquipmentColSort: action.inventoryEquipmentColSort,
                inventoryEquipmentIsSortedAsc: action.inventoryEquipmentIsSortedAsc,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded
            }
        case setInventoryEquipmentPageSize:
            return {
                ...state,
                inventoryEquipmentItems: {
                    ...state.inventoryEquipmentItems,
                    Pagination: {
                        ...state.inventoryEquipmentItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setInventoryEquipmentFilter:
            return {
                ...state,
                inventoryEquipmentTableFilterList: action.filterList
            }
        case applyInventoryEquipmentFilter:
            return {
                ...state,
                inventoryEquipmentTableFilterApply: action.applyFilter,
                inventoryEquipmentTableFilterList: action.filterList
            }             
        case getInventoryEquipmentDetailsById:
            return {
                ...state,
                inventoryEquipmentDetails: action.inventoryEquipmentDetails,
                isInventoryEquipmentLoaded: action.isInventoryEquipmentLoaded
            }
        case setFormSubmitted:
                return {
                    ...state
                    , formSubmitted: action.data
                };
        case getEquipmentdropDownList:
            return{
                ...state,
                inventoryEquipmentDropdownList: action.inventoryEquipmentDropDownList,
                isEquipmentdropDownListLoaded: action.isEquipmentdropDownListLoaded,
            }
        case resetInventoryEquipmentData:
            return {
                ...state,
                inventoryEquipmentItems: action.data
            };
        default:
            return state;
    }
};